<div class="settings-container">
  <!-- Security Section -->
  <div class="section-card">
    <!-- <h3 class="section-title">Security</h3> -->

    <div class="security-box">
      <div class="security-left">
        <div class="icon-box">
          <i class="fas fa-lock"></i>
        </div>
        <div>
          <h4 class="pwd-title">Password</h4>
          <p style="font-size: 14px;">Update your password to keep your account secure.</p>
        </div>
      </div>

      <button class="btn-outline" (click)="openPasswordModal()">
        
        {{ security?.flow === 'change' ? 'Change Password' : 'Set Password' }}
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════
             BANK ACCOUNT DETAILS — bottom info card
             ══════════════════════════════════════════ -->
  <div class="bank-info-card" *ngIf="bankAccountFetched && !bankAccountDetails">
    <div class="bank-info-icon">
      <i class="bi bi-bank2"></i>
    </div>
    <div class="bank-info-text">
      <h6 class="bank-info-title">Add your bank account details</h6>
      <p class="bank-info-desc">
        Add your bank account details to receive secure payment settlements and faster payouts.
        Your banking information is securely encrypted and used only for payment processing.
      </p>
      <span class="bank-info-secure"><i class="bi bi-lock-fill me-1"></i>Your details are 100% secure</span>
    </div>
    <div class="bank-info-action">
      <button type="button" class="btn btn-primary bank-add-btn" (click)="openBankAccountModal('add')">
        <i class="bi bi-bank2 me-2"></i>Add Bank Account Details
      </button>
    </div>
  </div>

  <!-- <div class="bank-info-card bank-info-card--added" *ngIf="bankAccountFetched && bankAccountDetails">
    <div class="bank-info-icon bank-info-icon--added">
      <i class="bi bi-bank2"></i>
      <span class="bank-added-check"><i class="bi bi-check-circle-fill"></i></span>
    </div>
    <div class="bank-info-text">
      <h6 class="bank-info-title">Bank Account Details</h6>
      <p class="bank-info-desc">
        Your bank account has been added successfully and will be used for payment settlements.
      </p>
    </div>
    <div class="bank-info-action">
      <button type="button" class="btn-bank-outline-primary bank-manage-btn" (click)="openBankAccountModal('view')">
        <i class="bi bi-bank2 me-2"></i>View / Manage Bank Details
      </button>
    </div>
  </div> -->

  <!-- Subscription Section -->
  <div class="section-card" *ngIf="role !== 'TM' && role !== 'GH'">
    <!-- <h3 class="section-title">Subscription</h3> -->
      <div class="section-header">
        <h3 class="section-title subtit">Subscription</h3>
        <div class="plan-action-btns">
          <button *ngIf="setLog?.actions?.primary !== null" class="pay-bill-btn" (click)="onPayBill()">
            {{ setLog?.actions?.primary?.label }}
          </button>

          <button *ngIf="setLog?.actions?.secondary !== null" type="button" class="cancel-subscription-btn" (click)="openCancelSubscriptionModal()"
            [disabled]="isCancellingSubscription">
            {{ setLog?.actions?.secondary?.label }}
          </button>
        </div>
      </div>

    <div class="subscription-wrapper">
      <div class="plan-card">
        <div class="crown-icon">
           <i class="bi bi-briefcase-fill"></i>
        </div>
        <span class="status active">Current Plan</span>
        <h4> {{ setLog.plan?.name }} </h4>
        <!-- <span class="status active">Active</span> -->
        <h5 class="status-badge" [ngClass]="getStatusClass(setLog?.status)">
          {{ formatStatus(setLog?.status) }}
        </h5>

        <p>Everything you need to run your practice efficiently.</p>

        <!-- <div style="margin-top: -5px;" *ngIf="setLog?.emandate?.status === 'pending'">
          <button class="btn-primary" (click)="eMandate()">eMandate Setup</button>
        </div> -->

      </div>

      <div class="subscription-details">
        <div class="detail-card">
          <div class="detail-icon">
            <i class="fas fa-wallet"></i>
          </div>
          <div>
            <span>Plan Details</span>
            <h5 *ngIf="setLog.plan?.amount > 0; else freePlan">
              {{ setLog.plan?.currencySymbol }}{{ setLog.plan?.amount | number }}
              / {{ setLog.plan?.cycle }}
            </h5>

            <ng-template #freePlan>
              <h5>{{ setLog.plan?.name }}</h5>
            </ng-template>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="fas fa-sync-alt"></i></div>
          <div>
            <span>Billing Cycle</span>
            <h5>{{ setLog.plan?.billingCycle }}</h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div>
            <span>Status</span>
              <h5 [ngClass]="getStatusClass(setLog?.status)">
                {{ formatStatus(setLog?.status)}}
              </h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="far fa-calendar"></i></div>
          <div>
            <span>Subscription Start Date</span>
            <h5>{{ setLog.startDate }}</h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="fas fa-shield-alt"></i></div>
          <div>
            <span>Plan Validity</span>
            <h5>{{ setLog.validity.label || 'N/A' }}</h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="far fa-calendar"></i></div>
          <div>
            <span>Next Billing Date</span>
            <h5>{{ setLog.nextBillingDate || 'N/A' }}</h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="far fa-credit-card"></i></div>
          <div>
            <span>Mode of Payment</span>
            <h5>{{ setLog.payment.method || 'N/A' }}</h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="far fa-calendar"></i></div>
          <div>
            <span>Account Activated On</span>
            <h5>{{ setLog.activatedOn || 'N/A' }}</h5>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-icon"><i class="far fa-file-alt"></i></div>
          <div>
            <span>T&amp;C Accepted On</span>
            <h5>
              {{ termsAcceptedOn ? (termsAcceptedOn | date:'MMM dd, yyyy') : 'N/A' }}
            </h5>
          </div>
        </div>

      
      </div>
    </div>

    <!-- <div class="renew-alert">
      <i class="fas fa-info-circle"></i>
      Your subscription will auto renew on <strong>Aug 06, 2026</strong>.
    </div> -->
  </div>


  <!-- Logged-in Devices Section -->
  <div class="section-card">
    <div class="section-header">
      <div>
        <h3 class="section-title">Logged-In Devices</h3>
        <p class="section-subtitle">These devices currently have access to your account.</p>
      </div>

      <!-- <button class="btn-outline small" (click)="openLogoutConfirm('all','device')">Log Out all other devices</button> -->
    </div>

    <div class="table-wrapper" *ngIf="loginTypeLog.length > 0; else noDevices">
      <table class="devices-table">
        <thead>
          <tr>
            <th>DEVICE</th>
            <th>DEVICE TYPE</th>
            <!-- <th>IP ADDRESS</th> -->
            <!-- <th>LOCATION</th> -->
            <th>LAST ACTIVE</th>
            <!-- <th>ACTION</th> -->
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let device of loginTypeLog">
            <td>
              <div class="device-info">
                <i class="fas" [ngClass]="getDeviceIcon(device.device_type)"></i>

                 <div>
                  <strong>{{ device.device_name }}</strong>
                  <span class="current-device" *ngIf="device.device_id === currentDeviceId">Current Device</span>
                </div>
              </div>
            </td>
        
            <td>{{ device.device_type || 'N/A' }}</td>
        
            <!-- <td>{{ device.ip_address || 'N/A' }}</td> -->
        
            <!-- <td>{{ device.location || 'N/A' }}</td> -->
        
            <td>{{ device.last_active || 'N/A' }}</td>
        
            <!-- <td>
              <button class="btn-danger small lout" (click)="openLogoutConfirm('single', device)">
                Log Out
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
      <!-- Empty State -->
      <ng-template #noDevices>
        <div class="empty-devices">
          <i class="fas fa-laptop"></i>
          <p>No logged-in devices found.</p>
        </div>
      </ng-template>
  </div>

  <!-- Danger Zone -->
  <div class="section-card danger-card" *ngIf="role !== 'TM' && role !== 'GH'">
    <!-- <h3 class="danger-title">Danger Zone</h3> -->

    <div class="danger-box">
      <div class="danger-left">
        <div class="danger-icon">
          <i class="fas fa-trash-alt"></i>
        </div>

        <div>
          <h4 class="danger-title">Delete Account</h4>
          <p class="pDel">Permanently delete your account and all associated data.</p>
          <span class="warning-text">This action cannot be undone.</span>
        </div>
      </div>

      <button class="btn-danger" (click)="openDeleteAccountModal()">Delete Account</button>
    </div>
  </div>
</div>





<!-- ══════════════════════════════════════════════════════════
     BANK ACCOUNT DETAILS MODAL
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showBankAccountModal" (click)="requestCloseBankAccountModal()"></div>
<div class="modal-panel modal-bank" *ngIf="showBankAccountModal" role="dialog" aria-modal="true"
  aria-labelledby="bankModalTitle">

  <form [formGroup]="bankAccountForm" (ngSubmit)="submitBankAccountDetails()"
    (keydown.enter)="blockEnterOnInput($event)" autocomplete="off">

    <div class="modal-header">
      <h6 class="modal-title uPwd" id="bankModalTitle">
        <i class="bi bi-bank2 me-2 uPwd"></i>Bank Account Details
      </h6>
      <button type="button" class="modal-close-btn" (click)="requestCloseBankAccountModal()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">

      <!-- ═══════════ VIEW MODE — read-only, masked ═══════════ -->
      <div class="form-grid" *ngIf="bankAccountModalMode === 'view'">
        <div class="form-group">
          <label class="form-label">Account Holder Name</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.account_holder_name || ''" disabled
            readonly>
        </div>
        <div class="form-group">
          <label class="form-label">Bank Name</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.bank_name || ''" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">Account Number</label>
          <input type="text" class="form-control" [value]="maskedBankAccountNumber" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">IFSC Code</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.ifsc_code || ''" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">Branch Name</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.branch_name || ''" disabled readonly>
        </div>
      </div>

      <div class="bank-verified-chip-row"
        *ngIf="bankAccountModalMode === 'view' && bankAccountDetails?.is_verified !== false">
        <span class="bank-verified-chip"><i class="bi bi-check-circle-fill me-1"></i>Verified</span>
        <span class="bank-verified-date" *ngIf="bankAccountDetails?.verified_on || bankAccountDetails?.verified_at">
          Account verified on {{ bankAccountDetails?.verified_on || bankAccountDetails?.verified_at }}
        </span>
      </div>

      <!-- ═══════════ ADD / EDIT MODE — editable form (unchanged Add flow) ═══════════ -->
      <div class="form-grid" *ngIf="bankAccountModalMode !== 'view'">

        <!-- Row 1: Account Holder Name / Bank Name -->
        <div class="form-group">
          <label class="form-label" for="bankAccountHolderName">Account Holder Name <span class="req">*</span></label>
          <input id="bankAccountHolderName" type="text" class="form-control"
            [class.is-invalid]="bankAccountForm.get('account_holder_name')?.invalid && bankAccountForm.get('account_holder_name')?.touched"
            formControlName="account_holder_name" placeholder="Enter account holder name" maxlength="100"
            autocomplete="off"
            (blur)="bankAccountForm.get('account_holder_name')?.setValue((bankAccountForm.get('account_holder_name')?.value || '').trim())">
          <div class="field-error"
            *ngIf="bankAccountForm.get('account_holder_name')?.invalid && bankAccountForm.get('account_holder_name')?.touched">
            <span *ngIf="bankAccountForm.get('account_holder_name')?.errors?.['required']">Account Holder Name is
              required.</span>
            <span *ngIf="!bankAccountForm.get('account_holder_name')?.errors?.['required']">Enter a valid account holder
              name.</span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="bankName">Bank Name <span class="req">*</span></label>
           <input id="bankName" type="text" class="form-control bn"
            [class.is-invalid]="bankAccountForm.get('bank_name')?.invalid && bankAccountForm.get('bank_name')?.touched"
            formControlName="bank_name" placeholder="Enter bank name" maxlength="100" autocomplete="off"
            name="fake-bank-field-9382" readonly onfocus="this.removeAttribute('readonly')"
            (blur)="bankAccountForm.get('bank_name')?.setValue((bankAccountForm.get('bank_name')?.value || '').trim())">

          <div class="field-error"
            *ngIf="bankAccountForm.get('bank_name')?.invalid && bankAccountForm.get('bank_name')?.touched">
            <span *ngIf="bankAccountForm.get('bank_name')?.errors?.['required']">Bank Name is required.</span>
            <span *ngIf="!bankAccountForm.get('bank_name')?.errors?.['required']">Enter a valid bank name.</span>
          </div>
        </div>

        <!-- Row 2: Account Number / Confirm Account Number -->
        <div class="form-group">
          <label class="form-label" for="bankAccountNumber">Account Number <span class="req">*</span></label>
          <div class="input-with-icon">
            <input id="bankAccountNumber" [type]="showAccountNumber ? 'text' : 'password'" class="form-control"
              [class.is-invalid]="bankAccountForm.get('account_number')?.invalid && bankAccountForm.get('account_number')?.touched"
              formControlName="account_number" placeholder="Enter account number" maxlength="18" inputmode="numeric"
              autocomplete="off" (input)="sanitizeNumericInput('account_number')">
            <button type="button" class="input-icon-btn" (click)="toggleAccountNumberVisibility()"
              [attr.aria-label]="showAccountNumber ? 'Hide account number' : 'Show account number'">
              <i class="bi" [class.bi-eye]="!showAccountNumber" [class.bi-eye-slash]="showAccountNumber"></i>
            </button>
          </div>
          <div class="field-error"
            *ngIf="bankAccountForm.get('account_number')?.invalid && bankAccountForm.get('account_number')?.touched">
            <span *ngIf="bankAccountForm.get('account_number')?.errors?.['required']">Account Number is required.</span>
            <span *ngIf="!bankAccountForm.get('account_number')?.errors?.['required']">Enter a valid account
              number.</span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="bankConfirmAccountNumber">Confirm Account Number <span
              class="req">*</span></label>
          <div class="input-with-icon">
            <input id="bankConfirmAccountNumber" [type]="showConfirmAccountNumber ? 'text' : 'password'"
              class="form-control"
              [class.is-invalid]="(bankAccountForm.get('confirm_account_number')?.invalid || bankAccountForm.hasError('accountNumberMismatch')) && bankAccountForm.get('confirm_account_number')?.touched"
              formControlName="confirm_account_number" placeholder="Re-enter account number" maxlength="18"
              inputmode="numeric" autocomplete="off" (input)="sanitizeNumericInput('confirm_account_number')">
            <button type="button" class="input-icon-btn" (click)="toggleConfirmAccountNumberVisibility()"
              [attr.aria-label]="showConfirmAccountNumber ? 'Hide account number' : 'Show account number'">
              <i class="bi" [class.bi-eye]="!showConfirmAccountNumber"
                [class.bi-eye-slash]="showConfirmAccountNumber"></i>
            </button>
            <i class="bi bi-check-circle-fill input-verified-tick"
              *ngIf="bankAccountForm.get('confirm_account_number')?.value && !bankAccountForm.hasError('accountNumberMismatch') && bankAccountForm.get('confirm_account_number')?.valid"></i>
          </div>
          <div class="field-error"
            *ngIf="bankAccountForm.get('confirm_account_number')?.touched && bankAccountForm.hasError('accountNumberMismatch')">
            Account numbers do not match.
          </div>
          <div class="field-error"
            *ngIf="bankAccountForm.get('confirm_account_number')?.touched && !bankAccountForm.hasError('accountNumberMismatch') && bankAccountForm.get('confirm_account_number')?.errors?.['required']">
            Account Number is required.
          </div>
        </div>

        <!-- Row 3: IFSC Code / Branch Name -->
        <div class="form-group">
          <label class="form-label" for="bankIfscCode">IFSC Code <span class="req">*</span></label>
          <input id="bankIfscCode" type="text" class="form-control"
            [class.is-invalid]="bankAccountForm.get('ifsc_code')?.invalid && bankAccountForm.get('ifsc_code')?.touched"
            formControlName="ifsc_code" placeholder="Enter IFSC code (e.g. SBIN0001234)" maxlength="11"
            style="text-transform:uppercase;">
          <div class="field-error"
            *ngIf="bankAccountForm.get('ifsc_code')?.invalid && bankAccountForm.get('ifsc_code')?.touched">
            Enter a valid IFSC Code.
          </div>

          <!-- Verify action, aligned with the IFSC field -->
          <div class="bank-verify-row">
            <button type="button" class="btn-verify-outline bank-verify-btn" [disabled]="!canVerifyBankAccount"
              (click)="verifyBankAccount()">
              <span *ngIf="isBankAccountVerifying" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!isBankAccountVerifying" class="bi bi-shield-check me-1"></i>
              {{ isBankAccountVerifying ? 'Verifying...' : 'Verify' }}
            </button>
            <button type="button" class="bank-edit-link" *ngIf="isBankFieldsLocked" (click)="unlockBankFieldsForEdit()">
              <i class="bi bi-pencil-fill me-1"></i>Edit
            </button>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="bankBranchName">
            Branch Name
            <i class="bi bi-info-circle branch-tooltip-icon"
              matTooltip="Branch Name will be automatically fetched after successful verification using the IFSC Code."
              matTooltipPosition="above"></i>
          </label>
          <input id="bankBranchName" type="text" class="form-control" formControlName="branch_name"
            placeholder="Will appear after verification"
            matTooltip="Branch Name will be automatically fetched after successful verification using the IFSC Code."
            [matTooltipDisabled]="!bankAccountForm.get('branch_name')?.disabled" matTooltipPosition="above">
        </div>

      </div>

      <!-- Verification status banners (Add / Edit only) -->
      <div class="bank-status-banner bank-status-banner--success"
        *ngIf="bankAccountModalMode !== 'view' && isBankAccountVerified">
        <i class="bi bi-check-circle-fill me-2"></i>Bank account verified successfully.
      </div>
      <div class="bank-status-banner bank-status-banner--error"
        *ngIf="bankAccountModalMode !== 'view' && bankVerifyError">
        <i class="bi bi-exclamation-circle-fill me-2"></i>{{ bankVerifyError }}
      </div>

      <!-- Terms & Conditions (Add / Edit only) -->
      <label class="bank-terms-row" *ngIf="bankAccountModalMode !== 'view'">
        <input type="checkbox" class="bank-terms-checkbox" [(ngModel)]="bankTermsAccepted"
          [ngModelOptions]="{standalone: true}">
        <span>
          I have read and agree to the <a href="https://digicoffer.com/digicoffer_terms.pdf" target="_blank"
            rel="noopener">Terms &amp; Conditions</a>
          and <a href="https://digicoffer.com/digicoffer_privacy.pdf" target="_blank" rel="noopener">Privacy Policy</a>,
          and I authorize <a href="https://lexiz.ai/" target="_blank" rel="noopener">LexiZ.ai</a> to securely
          verify, process, and store my bank account details for payment settlements in accordance with applicable
          regulations.
        </span>
      </label>

    </div>

    <!-- VIEW MODE footer: Close / Edit Bank Details -->
    <div class="modal-footer" *ngIf="bankAccountModalMode === 'view'">
      <button type="button" class="btn btn-cancel" (click)="closeBankAccountModal()">
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="switchToEditMode()">
        <i class="bi bi-pencil-fill me-2"></i>Edit Bank Details
      </button>
    </div>

    <!-- ADD / EDIT MODE footer: Cancel / Submit or Save Changes -->
    <div class="modal-footer" *ngIf="bankAccountModalMode !== 'view'">
      <button type="button" class="btn btn-cancel" (click)="requestCloseBankAccountModal()"
        [disabled]="isBankAccountSubmitting">
        Cancel
      </button>
      <span class="bank-submit-tooltip-wrap"
        [attr.title]="!isBankSubmitEnabled ? 'Complete bank verification and accept the Terms &amp; Conditions to enable submission.' : null">
        <button type="submit" class="btn btn-primary" [disabled]="!isBankSubmitEnabled">
          <span *ngIf="isBankAccountSubmitting" class="spinner-border spinner-border-sm me-1"></span>
          {{ isBankAccountSubmitting ? (bankAccountModalMode === 'edit' ? 'Saving...' : 'Submitting...') :
          (bankAccountModalMode === 'edit' ? 'Save Changes' : 'Submit') }}
        </button>
      </span>
    </div>

  </form>
</div>

<!-- ───── Discard bank account changes confirmation dialog (reuses wa-confirm-*) ───── -->
<div class="wa-confirm-overlay" *ngIf="showBankDiscardConfirm" role="dialog" aria-modal="true"
  aria-labelledby="bankDiscardConfirmTitle">

  <div class="wa-confirm-dialog_rs">

    <!-- Close Icon -->
    <button type="button" class="wa-confirm-close_rs" aria-label="Close" (click)="keepEditingBankAccount()">
      <i class="fa fa-times"></i>
    </button>

    <h4 class="wa-confirm-title" id="bankDiscardConfirmTitle">
      Discard your changes?
    </h4>

    <p class="wa-confirm-message">
      Your unsaved changes will be lost.
    </p>

    <div class="wa-confirm-actions_rs">
      <button type="button" class="wa-btn-cancel_rs" (click)="keepEditingBankAccount()">
        Keep Editing
      </button>

      <button type="button" class="wa-btn-remove_rs" (click)="confirmDiscardBankChanges()">
        Discard
      </button>
    </div>

  </div>
</div>


<!-- ══════════════════════════════════════════════════════════
     UPDATE PASSWORD MODAL
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showPasswordModal" (click)="closePasswordModal()"></div>
<div class="modal-panel modal-password" *ngIf="showPasswordModal" role="dialog" aria-modal="true"
  aria-labelledby="pwdModalTitle">

  <form [formGroup]="passwordForm" (ngSubmit)="submitPasswordChange()" autocomplete="off">

    <div class="modal-header">
      <h6 class="modal-title uPwd" id="pwdModalTitle">{{ security?.flow === 'change' ? 'Update Password' : 'Set Password' }}</h6>
      <button type="button" class="modal-close-btn" (click)="closePasswordModal()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">

      <!-- honeypots to stop Chrome autofill -->
      <input type="text" style="display:none" tabindex="-1" autocomplete="off">
      <input type="password" style="display:none" tabindex="-1" autocomplete="off">

      <!-- <div class="form-group" *ngIf="security?.flow === 'change'">
        <label class="form-label uField" for="currentPassword">Current Password</label>
        <div class="input-with-icon">
          <input id="currentPassword" [type]="showCurrentPwd ? 'text' : 'password'" class="form-control fp"
            [class.is-invalid]="passwordForm.get('current_password')?.invalid && passwordForm.get('current_password')?.touched"
            formControlName="current_password" placeholder="Enter your current password"
            autocomplete="new-password" name="cur-pwd-8123"
            [readonly]="isCurrentPwdReadonly" (focus)="isCurrentPwdReadonly = false"
            (blur)="passwordForm.get('current_password')?.markAsTouched()">
          <button type="button" class="input-icon-btn" (click)="showCurrentPwd = !showCurrentPwd"
            [attr.aria-label]="showCurrentPwd ? 'Hide password' : 'Show password'">
            <i class="bi" [class.bi-eye]="!showCurrentPwd" [class.bi-eye-slash]="showCurrentPwd"></i>
          </button>
        </div>
        <div class="field-error"
          *ngIf="passwordForm.get('current_password')?.invalid && passwordForm.get('current_password')?.touched">
          <span *ngIf="passwordForm.get('current_password')?.errors?.['required']">Current password is required.</span>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label uField" for="newPassword">New Password</label>
        <div class="input-with-icon">
          <input id="newPassword" [type]="showNewPwd ? 'text' : 'password'" class="form-control fp"
            [class.is-invalid]="passwordForm.get('new_password')?.invalid && passwordForm.get('new_password')?.touched"
            formControlName="new_password" placeholder="Enter your new password"
            autocomplete="new-password" name="new-pwd-8123"
            [readonly]="isNewPwdReadonly" (focus)="isNewPwdReadonly = false"
            (blur)="passwordForm.get('new_password')?.markAsTouched()">
          <button type="button" class="input-icon-btn" (click)="showNewPwd = !showNewPwd"
            [attr.aria-label]="showNewPwd ? 'Hide password' : 'Show password'">
            <i class="bi" [class.bi-eye]="!showNewPwd" [class.bi-eye-slash]="showNewPwd"></i>
          </button>
        </div>
        <div class="field-error"
          *ngIf="passwordForm.get('new_password')?.invalid && passwordForm.get('new_password')?.touched">
          <span *ngIf="passwordForm.get('new_password')?.errors?.['required']">New password is required.</span>
          <span *ngIf="passwordForm.get('new_password')?.errors?.['minlength']">Password must be at least 8 characters.</span>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label uField" for="confirmNewPassword">Confirm Password</label>
        <div class="input-with-icon">
          <input id="confirmNewPassword" [type]="showConfirmPwd ? 'text' : 'password'" class="form-control fp"
            [class.is-invalid]="(passwordForm.get('confirm_password')?.invalid || passwordForm.hasError('passwordMismatch')) && passwordForm.get('confirm_password')?.touched"
            formControlName="confirm_password" placeholder="Enter your new password"
            autocomplete="new-password" name="conf-pwd-8123"
            [readonly]="isConfirmPwdReadonly" (focus)="isConfirmPwdReadonly = false"
            (blur)="passwordForm.get('confirm_password')?.markAsTouched()">
          <button type="button" class="input-icon-btn" (click)="showConfirmPwd = !showConfirmPwd"
            [attr.aria-label]="showConfirmPwd ? 'Hide password' : 'Show password'">
            <i class="bi" [class.bi-eye]="!showConfirmPwd" [class.bi-eye-slash]="showConfirmPwd"></i>
          </button>
        </div>
        <div class="field-error" *ngIf="passwordForm.get('confirm_password')?.touched && passwordForm.hasError('passwordMismatch')">
          Passwords do not match.
        </div>
        <div class="field-error"
          *ngIf="passwordForm.get('confirm_password')?.touched && !passwordForm.hasError('passwordMismatch') && passwordForm.get('confirm_password')?.errors?.['required']">
          Please confirm your new password.
        </div>
      </div> -->


      <!-- Current Password -->
      <div class="form-group" *ngIf="security?.flow === 'change'">
      
        <label class="form-label uField" for="currentPassword">
          Current Password
        </label>
      
        <div class="password-input-wrapper">
      
          <input id="currentPassword" [type]="showCurrentPwd ? 'text' : 'password'" class="form-control fp password-input"
            [class.is-invalid]="
              passwordForm.get('current_password')?.invalid &&
              passwordForm.get('current_password')?.touched
            " formControlName="current_password" placeholder="Enter your current password" autocomplete="new-password"
            name="cur-pwd-8123" [readonly]="isCurrentPwdReadonly" (focus)="isCurrentPwdReadonly = false"
            (blur)="passwordForm.get('current_password')?.markAsTouched()">
      
          <button type="button" class="password-eye-btn" (click)="showCurrentPwd = !showCurrentPwd"
            [attr.aria-label]="showCurrentPwd ? 'Hide password' : 'Show password'">
      
            <i class="bi" [class.bi-eye]="showCurrentPwd" [class.bi-eye-slash]="!showCurrentPwd">
            </i>
      
          </button>
      
        </div>
      
        <div class="field-error" *ngIf="
            passwordForm.get('current_password')?.invalid &&
            passwordForm.get('current_password')?.touched
          ">
      
          <span *ngIf="passwordForm.get('current_password')?.errors?.['required']">
      
            Current password is required.
      
          </span>
      
        </div>
      
      </div>
      
      <!-- New Password -->
      <div class="form-group">

        <label class="form-label uField" for="newPassword">New Password</label>

        <div class="password-input-wrapper">

          <input id="newPassword" [type]="showNewPwd ? 'text' : 'password'" class="form-control fp password-input"
            [class.is-invalid]="
              passwordForm.get('new_password')?.invalid &&
              passwordForm.get('new_password')?.value &&
              passwordForm.get('new_password')?.touched
            " formControlName="new_password" placeholder="Enter your new password" autocomplete="new-password"
            name="new-pwd-8123" [readonly]="isNewPwdReadonly" (focus)="isNewPwdReadonly = false"
            (blur)="passwordForm.get('new_password')?.markAsTouched()">

          <button type="button" class="password-eye-btn" (click)="showNewPwd = !showNewPwd"
            [attr.aria-label]="showNewPwd ? 'Hide password' : 'Show password'">

            <i class="bi" [class.bi-eye]="showNewPwd" [class.bi-eye-slash]="!showNewPwd">
            </i>

          </button>

        </div>

        <div class="password-rules mt-2" *ngIf="passwordForm.get('new_password')?.value">
        
          <div [class.rule-valid]="hasMinLength(passwordForm.get('new_password')?.value)"
            [class.rule-invalid]="!hasMinLength(passwordForm.get('new_password')?.value)">
        
            <i class="bi" [class.bi-check-circle-fill]="hasMinLength(passwordForm.get('new_password')?.value)"
              [class.bi-circle]="!hasMinLength(passwordForm.get('new_password')?.value)">
            </i>
        
            At least 8 characters
          </div>
        
          <div [class.rule-valid]="hasUppercase(passwordForm.get('new_password')?.value)"
            [class.rule-invalid]="!hasUppercase(passwordForm.get('new_password')?.value)">
        
            <i class="bi" [class.bi-check-circle-fill]="hasUppercase(passwordForm.get('new_password')?.value)"
              [class.bi-circle]="!hasUppercase(passwordForm.get('new_password')?.value)">
            </i>
        
            At least 1 uppercase letter
          </div>
        
          <div [class.rule-valid]="hasLowercase(passwordForm.get('new_password')?.value)"
            [class.rule-invalid]="!hasLowercase(passwordForm.get('new_password')?.value)">
        
            <i class="bi" [class.bi-check-circle-fill]="hasLowercase(passwordForm.get('new_password')?.value)"
              [class.bi-circle]="!hasLowercase(passwordForm.get('new_password')?.value)">
            </i>
        
            At least 1 lowercase letter
          </div>
        
          <div [class.rule-valid]="hasNumber(passwordForm.get('new_password')?.value)"
            [class.rule-invalid]="!hasNumber(passwordForm.get('new_password')?.value)">
        
            <i class="bi" [class.bi-check-circle-fill]="hasNumber(passwordForm.get('new_password')?.value)"
              [class.bi-circle]="!hasNumber(passwordForm.get('new_password')?.value)">
            </i>
        
            At least 1 number
          </div>
        
          <div [class.rule-valid]="hasSpecialCharacter(passwordForm.get('new_password')?.value)"
            [class.rule-invalid]="!hasSpecialCharacter(passwordForm.get('new_password')?.value)">
        
            <i class="bi" [class.bi-check-circle-fill]="hasSpecialCharacter(passwordForm.get('new_password')?.value)"
              [class.bi-circle]="!hasSpecialCharacter(passwordForm.get('new_password')?.value)">
            </i>
        
            At least 1 special character
          </div>
        
        </div>

      </div>
      
      <!-- Confirm Password -->
      <div class="form-group">
      
        <label class="form-label uField" for="confirmNewPassword">Confirm Password</label>
      
        <div class="password-input-wrapper">
      
          <input id="confirmNewPassword" [type]="showConfirmPwd ? 'text' : 'password'" class="form-control fp password-input"
            [class.is-invalid]="
                    passwordForm.get('confirm_password')?.value &&
                    (
                      passwordForm.hasError('passwordMismatch') ||
                      passwordForm.get('confirm_password')?.hasError('required')
                    )
                  " formControlName="confirm_password" placeholder="Enter your new password" autocomplete="new-password"
            name="conf-pwd-8123" [readonly]="isConfirmPwdReadonly" (focus)="isConfirmPwdReadonly = false"
            (blur)="passwordForm.get('confirm_password')?.markAsTouched()">
      
          <button type="button" class="password-eye-btn" (click)="showConfirmPwd = !showConfirmPwd"
            [attr.aria-label]="showConfirmPwd ? 'Hide password' : 'Show password'">
      
            <i class="bi" [class.bi-eye]="showConfirmPwd" [class.bi-eye-slash]="!showConfirmPwd">
            </i>
      
          </button>
      
        </div>
      
      
        <!-- Password mismatch -->
        <div class="field-error" *ngIf="
                  passwordForm.get('confirm_password')?.value &&
                  passwordForm.hasError('passwordMismatch')">
          Passwords do not match.
        </div>
      
      
        <!-- Required -->
        <div class="field-error" *ngIf="
                  passwordForm.get('confirm_password')?.touched &&
                  passwordForm.get('confirm_password')?.hasError('required')
                ">
          Please confirm your new password.
        </div>
      
      </div>

      <div class="bank-status-banner bank-status-banner--error" *ngIf="passwordChangeError">
        <i class="bi bi-exclamation-circle-fill me-2"></i>{{ passwordChangeError }}
      </div>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-cancel" (click)="closePasswordModal()" [disabled]="isPasswordSubmitting">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="passwordForm.invalid || isPasswordSubmitting">
        <span *ngIf="isPasswordSubmitting" class="spinner-border spinner-border-sm me-1"></span>
        {{ isPasswordSubmitting ? 'Saving...' : 'Save Password' }}
      </button>
    </div>

  </form>
</div>


<!-- ══════════════════════════════════════════════════════════
     LOG OUT CONFIRM DIALOG (single device / all other devices)
══════════════════════════════════════════════════════════ -->
<div class="wa-confirm-overlay" *ngIf="showLogoutConfirm" role="dialog" aria-modal="true"
  aria-labelledby="logoutConfirmTitle">

  <div class="wa-confirm-dialog_rs">

    <button type="button" class="wa-confirm-close_rs" aria-label="Close" (click)="cancelLogout()">
      <i class="fa fa-times"></i>
    </button>

    <span class="wa-confirm-icon_rs">
      <i class="bi bi-box-arrow-right"></i>
    </span>

    <h4 class="wa-confirm-title" id="logoutConfirmTitle">
      {{ logoutTarget === 'all' ? 'Log out of all devices?' : 'Log out of this device?' }}
    </h4>

    <p class="wa-confirm-message">
      <ng-container *ngIf="logoutTarget === 'all'">
        You will be logged out of all other active sessions on other devices <strong>except this one</strong>.
      </ng-container>
      <ng-container *ngIf="logoutTarget === 'single'">
        You will be logged out of <strong>{{ logoutDeviceName }}</strong>. This device will need to sign in again to access your account.
      </ng-container>
    </p>

    <div class="wa-confirm-actions_rs wa-confirm-actions_rs--stacked">

      <button type="button" class="wa-btn-cancel_rs" (click)="cancelLogout()" [disabled]="isLoggingOut">
        Cancel
      </button>

      <button type="button" class="wa-btn-remove_rs" (click)="confirmLogout()" [disabled]="isLoggingOut">
        <span *ngIf="isLoggingOut" class="spinner-border spinner-border-sm me-1"></span>
        {{ isLoggingOut ? 'Logging out...' : 'Log out' }}
      </button>
    </div>

  </div>
</div>


<!-- ══════════════════════════════════════════════════════════
     DELETE ACCOUNT CONFIRM DIALOG (email-typed confirmation)
══════════════════════════════════════════════════════════ -->
<div class="wa-confirm-overlay" *ngIf="showDeleteAccountConfirm" role="dialog" aria-modal="true"
  aria-labelledby="deleteAccountConfirmTitle">

  <div class="wa-confirm-dialog_rs wa-confirm-dialog_rs--wide">

    <button type="button" class="wa-confirm-close_rs" aria-label="Close" (click)="cancelDeleteAccount()">
      <i class="fa fa-times"></i>
    </button>

    <div class="wa-confirm-icon_rs wa-confirm-icon_rs--danger">
      <i class="bi bi-exclamation-triangle-fill"></i>
    </div>

    <h4 class="wa-confirm-title" id="deleteAccountConfirmTitle">
      Delete Your Account Permanently?
    </h4>

    <p class="wa-confirm-message">
      This action cannot be undone. Your account will be permanently deleted, and you will no longer be able to access it.
    </p>

    <label class="form-label" for="deleteConfirmEmail" style="margin-top: 16px; display:block;">
      Please type in your email to confirm.
    </label>
    <!-- <input id="deleteConfirmEmail" type="text" class="form-control" name="del-conf-em-8123" autocomplete="off"
      [(ngModel)]="deleteConfirmEmailInput" [ngModelOptions]="{standalone: true}"
      [placeholder]="currentUserEmail"> -->
      <input #deleteEmailInput id="deleteConfirmEmail" type="text" class="form-control" name="del-conf-em-8123" autocomplete="off"
        [(ngModel)]="deleteConfirmEmailInput" [ngModelOptions]="{ standalone: true }" placeholder="Enter your email" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px;">

    <div class="wa-confirm-actions_rs wa-confirm-actions_rs--stacked" style="margin-top: 16px;">
      <button type="button" class="wa-btn-cancel_rs" (click)="cancelDeleteAccount()" [disabled]="isDeletingAccount">
        No, Keep it
      </button>
      
      <button type="button" class="wa-btn-remove_rs delac"
        (click)="confirmDeleteAccount()">
        <span *ngIf="isDeletingAccount" class="spinner-border spinner-border-sm me-1"></span>
        {{ isDeletingAccount ? 'Deleting...' : 'Yes, Delete Account' }}
      </button>
    </div>

  </div>
</div>


<!-- ═══════════════════════════════  ═══════════════════════════
     PLAN MODAL (Upgrade / Downgrade)
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showPlanModal" (click)="closePlanModal()"></div>
<div class="modal-panel modal-plan" *ngIf="showPlanModal">

  <div class="modal-header"
       [class.modal-header-upgrade]="planModalMode === 'upgrade'"
       [class.modal-header-downgrade]="planModalMode === 'downgrade'">
    <h6 class="modal-title">
      <i class="bi me-2"
         [class.bi-arrow-up-circle]="planModalMode === 'upgrade'"
         [class.bi-arrow-down-circle]="planModalMode === 'downgrade'"></i>
      {{ planModalMode === 'upgrade' ? 'Upgrade Plan' : 'Downgrade Plan' }}
    </h6>
    <button class="modal-close-btn" (click)="closePlanModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Loading skeleton -->
  <div class="modal-body" *ngIf="planModalLoading">
    <div class="plan-skeleton">
      <div class="plan-sk-row"></div>
      <div class="plan-sk-row wide"></div>
      <div class="plan-sk-row wide"></div>
      <div class="plan-sk-row"></div>
    </div>
  </div>

  <!-- Content -->
  <div class="modal-body" *ngIf="!planModalLoading && planModalData">

    <!-- Current plan banner -->
    <div class="current-plan-banner">
      <span class="cp-label">Current Plan</span>
      <span class="cp-name">{{ planModalData.current_plan?.name }}</span>
      <span class="cp-price">
        {{ planModalData.current_plan?.currency }}
        {{ planModalData.current_plan?.price | number:'1.0-0' }}/mo
      </span>
      <span class="cp-status"
            [class.cp-status--active]="planModalData.sub_status === 'active'"
            [class.cp-status--inactive]="planModalData.sub_status !== 'active'">
        {{ planModalData.sub_status | titlecase }}
      </span>
    </div>

    <!-- No options -->
    <div class="no-plan-options" *ngIf="planOptions.length === 0">
      <i class="bi bi-info-circle me-2"></i>
      No {{ planModalMode }} options available for this account.
    </div>

    <!-- Plan option cards -->
    <div class="plan-options-list" *ngIf="planOptions.length > 0">
      <label class="plan-option-card"
             *ngFor="let opt of planOptions"
             [class.plan-option-card--selected]="selectedPlanKey === opt.key"
             (click)="selectedPlanKey = opt.key">
        <input type="radio" name="planChoice" [value]="opt.key"
               [(ngModel)]="selectedPlanKey" style="display:none">
        <div class="poc-left">
          <div class="poc-radio">
            <i class="bi"
               [class.bi-record-circle-fill]="selectedPlanKey === opt.key"
               [class.bi-circle]="selectedPlanKey !== opt.key"></i>
          </div>
          <div class="poc-info">
            <span class="poc-name">{{ opt.name }}</span>
            <span class="poc-label">{{ opt.pricing?.label }}</span>
          </div>
        </div>
        <div class="poc-price">
          <span class="poc-amount">{{ opt.currency }} {{ opt.price | number:'1.0-0' }}</span>
          <span class="poc-period">/mo</span>
        </div>
      </label>
    </div>

    <!-- Pricing summary — UPGRADE -->
    <div class="pricing-summary"
         *ngIf="planModalMode === 'upgrade' && selectedPlanKey && getSelectedPlanPricing() as pricing">
      <div class="ps-row">
        <span>Remaining value on current plan</span>
        <span>{{ pricing.currency }} {{ pricing.remaining_value | number:'1.2-2' }}</span>
      </div>
      <div class="ps-row">
        <span>Remaining days</span>
        <span>{{ pricing.remaining_days }} days</span>
      </div>
      <div class="ps-row ps-highlight">
        <span>Amount due now</span>
        <strong>{{ pricing.currency }} {{ pricing.adjustment_amount | number:'1.2-2' }}</strong>
      </div>
      <p class="ps-note">
        <i class="bi bi-envelope me-1"></i>
        A payment link will be sent to <strong>{{ planModalData.email }}</strong>
      </p>
    </div>

    <!-- Pricing summary — DOWNGRADE -->
    <div class="pricing-summary pricing-summary--downgrade"
         *ngIf="planModalMode === 'downgrade' && selectedPlanKey && getSelectedPlanPricing() as pricing">
      <div class="ps-row">
        <span>Monthly saving</span>
        <span class="ps-saving">{{ pricing.currency }} {{ pricing.saving | number:'1.2-2' }}/mo</span>
      </div>
      <div class="ps-row">
        <span>Effective date</span>
        <span>{{ pricing.effective_date }}</span>
      </div>
      <p class="ps-note ps-note--warning">
        <i class="bi bi-clock-history me-1"></i>
         After submitting your request, our team will review it. Your current subscription will continue until the downgrade is approved and becomes effective.
      </p>
    </div>

    <!-- Downgrade reason -->
    <div class="form-group downgrade-reason-wrap"
         *ngIf="planModalMode === 'downgrade' && planOptions.length > 0">
      <label class="form-label">
        Reason for Downgrade <span class="req">*</span>
      </label>
      <textarea class="form-control" rows="3"
                placeholder="Enter the Reason"
                [(ngModel)]="downgradeReason"
                (ngModelChange)="downgradeReasonError = ''"
                [class.is-invalid]="downgradeReasonError">
      </textarea>
      <div class="field-error" *ngIf="downgradeReasonError">{{ downgradeReasonError }}</div>
    </div>

  </div>

  <div class="modal-footer" *ngIf="!planModalLoading">
    <button class="btn btn-cancel" (click)="closePlanModal()" [disabled]="isPlanSubmitting">
      Cancel
    </button>
    <button class="btn"
            [class.btn-upgrade]="planModalMode === 'upgrade'"
            [class.btn-downgrade]="planModalMode === 'downgrade'"
            (click)="submitPlanChange()"
            [disabled]="isPlanSubmitting || planOptions.length === 0 || !selectedPlanKey">
      <span *ngIf="isPlanSubmitting" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isPlanSubmitting" class="bi me-1"
         [class.bi-arrow-up-circle]="planModalMode === 'upgrade'"
         [class.bi-arrow-down-circle]="planModalMode === 'downgrade'"></i>
      {{ isPlanSubmitting
          ? 'Processing...'
          : (planModalMode === 'upgrade' ? 'Confirm Upgrade' : 'Submit Downgrade') }}
    </button>
  </div>

</div>

<!-- =========================================================
     CANCEL SUBSCRIPTION MODAL
     ========================================================= -->

<div
  class="modal-backdrop"
  *ngIf="showCancelSubscriptionModal"
  (click)="closeCancelSubscriptionModal()">
</div>

<div
  class="modal-panel cancel-subscription-modal"
  *ngIf="showCancelSubscriptionModal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="cancelSubscriptionTitle">

  <!-- Header -->
  <div class="cancel-modal-header">

    <!-- <div class="cancel-warning-icon">
      <i class="bi bi-exclamation-triangle-fill"></i>
    </div> -->

    <button
      type="button"
      class="modal-close-btn"
      (click)="closeCancelSubscriptionModal()"
      [disabled]="isCancellingSubscription"
      aria-label="Close">

      <i class="bi bi-x-lg"></i>

    </button>

  </div>


  <!-- Body -->
  <div class="cancel-modal-body">

    <h3 id="cancelSubscriptionTitle">
      Cancel Subscription?
    </h3>

    <p class="cancel-description">
      Are you sure you want to cancel your subscription?
    </p>

    <div class="cancel-info-box">

      <i class="bi bi-info-circle-fill"></i>

      <div>
        <strong>What happens next?</strong>

        <ul>
          <li>Your subscription will be cancelled.</li>
          <li>You may continue to access your plan until the current billing period ends.</li>
          <li>You will not be charged for the next billing cycle.</li>
        </ul>
      </div>

    </div>

    <!-- API Error -->
    <div
      *ngIf="cancelSubscriptionError"
      class="cancel-error">

      <i class="bi bi-exclamation-circle-fill"></i>

      <span>
        {{ cancelSubscriptionError }}
      </span>

    </div>

  </div>


  <!-- Footer -->
  <div class="cancel-modal-footer">

    <button
      type="button"
      class="cancel-no-btn"
      (click)="closeCancelSubscriptionModal()"
      [disabled]="isCancellingSubscription">
      Keep Subscription
    </button>

    <button
      type="button"
      class="cancel-yes-btn"
      (click)="cancelSubscription()"
      [disabled]="isCancellingSubscription">

      <span
        *ngIf="isCancellingSubscription"
        class="spinner-border spinner-border-sm me-1">
      </span>

      {{ isCancellingSubscription ? 'Cancelling...' : 'Cancel Subscription' }}

    </button>

  </div>

</div>


<!-- =========================================================
     eMandate MODAL
     ========================================================= -->

<div class="modal-backdrop" *ngIf="showeMandateSubscriptionModal" (click)="closeeMandateSubscriptionModal()">
</div>

<div class="modal-panel cancel-subscription-modal" *ngIf="showeMandateSubscriptionModal" role="dialog" aria-modal="true"
  aria-labelledby="cancelSubscriptionTitle">

  <!-- Header -->
  <!-- <div class="cancel-modal-header">
    <button type="button" class="modal-close-btn" (click)="closeeMandateSubscriptionModal()"
      [disabled]="isCancellingSubscription" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div> -->


  <div class="cancel-modal-body" style="padding: 18px 24px 0px !important;">
    <h3 id="cancelSubscriptionTitle">
      <div class="eManSuccess">
        <i class="fa fa-check"></i>
      </div>

      eMandate set up
    </h3>
    <p class="cancel-description">Renewals will now be auto-debited from your linked bank account.</p>
  </div>

  <div class="cancel-modal-footer">
    <button type="button" class="cancel-no-btn" (click)="closeeMandateSubscriptionModal()"
      [disabled]="isCancellingSubscription">
      OK
    </button>
  </div>

</div>


<!-- <ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner> -->